/** The ten Sorting House chapters (10 levels each). */
export interface SortingChapter {
  readonly chapter: number;
  readonly themeId: string;
  readonly name: string;
  readonly focus: string;
  readonly firstLevel: number;
  readonly lastLevel: number;
  /** UI accent colours (background gradient top/bottom). */
  readonly palette: readonly [string, string];
}

const chapter = (
  n: number,
  themeId: string,
  name: string,
  focus: string,
  palette: readonly [string, string],
): SortingChapter => ({
  chapter: n,
  themeId,
  name,
  focus,
  firstLevel: (n - 1) * 10 + 1,
  lastLevel: n * 10,
  palette,
});

export const SORTING_CHAPTERS: readonly SortingChapter[] = [
  chapter(1, "toy-shop", "Tiệm đồ chơi", "Xếp theo loại đồ vật", ["#ffe3ef", "#ffd0e4"]),
  chapter(2, "bakery", "Quầy bánh ngọt", "Thêm món, thêm khay, xếp theo kích thước", ["#fff0d6", "#ffe0b0"]),
  chapter(3, "garden", "Khu vườn", "Hình dạng và loại", ["#e4f8e4", "#c9efd2"]),
  chapter(4, "bow-workshop", "Xưởng nơ", "Kết hợp màu và hình", ["#f3e6ff", "#e2ccff"]),
  chapter(5, "secret-storage", "Kho bí mật", "Khay có giới hạn, đồ đến theo lượt", ["#e3efff", "#c9dcff"]),
  chapter(6, "magic-festival", "Lễ hội phép", "Chuông phép đổi luật khay", ["#fff3c8", "#ffe39a"]),
  chapter(7, "night-shop", "Cửa hàng đêm", "Nhiều nhóm hơn", ["#dfe2ff", "#c3c8f5"]),
  chapter(8, "gift-room", "Phòng quà", "Xếp chồng từ lớn đến nhỏ", ["#ffe6e0", "#ffd0c4"]),
  chapter(9, "fair", "Hội chợ", "Kết hợp nhiều luật", ["#e0fbf4", "#bff0e2"]),
  chapter(10, "grand-celebration", "Đại lễ", "Thử thách bậc thầy", ["#fff0f7", "#f6d9ff"]),
];

export function chapterOfLevel(levelId: number): SortingChapter {
  const found = SORTING_CHAPTERS[Math.floor((levelId - 1) / 10)];
  if (!found) throw new RangeError(`no chapter for level ${levelId}`);
  return found;
}
